import { Main, Split, Bottoms } from '@styles/components/ModalBodyStyle';
import * as S from '@styles/components/FormStyle';
import { ColorTypes } from '@typedef/components/Device/Color/color.types';

type Props = {
  type: string;
  inputs: Partial<ColorTypes>;
  onChangeInputs: (e: { target: HTMLInputElement }) => void;
  save: () => Promise<void>;
};

const ColorManage = ({ type, inputs, onChangeInputs, save }: Props) => {
  return (
    <Main width={35}>
      <Split>
        <S.InputBox isRow>
          <p>
            색상명<span>*</span>
          </p>
          <S.Input
            name='name'
            onBlur={onChangeInputs}
            defaultValue={inputs.name}
            placeholder='색상명'
          />
        </S.InputBox>
        <S.InputBox isRow>
          <p>
            영어명<span>*</span>
          </p>
          <S.Input
            name='name_eng'
            onBlur={onChangeInputs}
            defaultValue={inputs.name_eng}
            placeholder='영어명'
          />
        </S.InputBox>
      </Split>
      <Bottoms>
        <button type='button' onClick={save}>
          색상 {type}하기
        </button>
      </Bottoms>
    </Main>
  );
};

export default ColorManage;
